export const BaseModalWidthUtils = {
  smallWidth: 680,
  mediumWidth: 700,
  largeWidth: 750,
  xLargeWidth: 980,
  halfPercentWidth: '50%',
} as const;
